import React from 'react';

const Services = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Our SMS Marketing Services</h1>
          
          <div className="features-grid">
            <div className="feature-card">
              <h3>A2P SMS Messaging</h3>
              <p>Professional Application-to-Person messaging services through our partnerships with leading SMS providers. 
              Ideal for marketing campaigns, notifications, and customer communications.</p>
              <ul style={{textAlign: 'left', marginTop: '1rem'}}>
                <li>Partnered with approved providers</li>
                <li>Reliable deliverability</li>
                <li>Bulk messaging capabilities</li>
                <li>Real-time delivery reports</li>
              </ul>
            </div>

            <div className="feature-card">
              <h3>Campaign Management</h3>
              <p>End-to-end campaign management services including strategy development, content creation, 
              scheduling, and performance optimization.</p>
              <ul style={{textAlign: 'left', marginTop: '1rem'}}>
                <li>Campaign strategy development</li>
                <li>Content creation and optimization</li>
                <li>Automated scheduling</li>
                <li>A/B testing capabilities</li>
              </ul>
            </div>

            <div className="feature-card">
              <h3>Compliance Management</h3>
              <p>Comprehensive compliance services ensuring all campaigns meet TCPA, CAN-SPAM, and carrier requirements. 
              We handle all regulatory aspects so you can focus on your business.</p>
              <ul style={{textAlign: 'left', marginTop: '1rem'}}>
                <li>TCPA compliance auditing</li>
                <li>Consent management</li>
                <li>Opt-out processing</li>
                <li>Regulatory reporting</li>
              </ul>
            </div>

            <div className="feature-card">
              <h3>Analytics & Reporting</h3>
              <p>Advanced analytics and reporting tools to track campaign performance, measure ROI, and optimize 
              messaging strategies for maximum effectiveness.</p>
              <ul style={{textAlign: 'left', marginTop: '1rem'}}>
                <li>Real-time analytics dashboard</li>
                <li>Delivery and engagement metrics</li>
                <li>ROI tracking and reporting</li>
                <li>Custom reporting options</li>
              </ul>
            </div>

            <div className="feature-card">
              <h3>Platform Integration</h3>
              <p>Integration support for connecting with SMS platforms and your existing systems, CRM platforms, 
              and business applications.</p>
              <ul style={{textAlign: 'left', marginTop: '1rem'}}>
                <li>Platform setup assistance</li>
                <li>Integration guidance</li>
                <li>CRM connection support</li>
                <li>Technical documentation</li>
              </ul>
            </div>

            <div className="feature-card">
              <h3>Dedicated Support</h3>
              <p>Professional support and account management to ensure your campaigns run smoothly 
              and achieve optimal results.</p>
              <ul style={{textAlign: 'left', marginTop: '1rem'}}>
                <li>Email and phone support</li>
                <li>Account management</li>
                <li>Campaign optimization consulting</li>
                <li>Training and onboarding</li>
              </ul>
            </div>
          </div>

          <div style={{marginTop: '4rem', textAlign: 'center'}}>
            <h2 style={{color: '#2563eb', marginBottom: '2rem'}}>Custom Service Solutions</h2>
            
            <div style={{background: '#f0f9ff', padding: '3rem', borderRadius: '12px', border: '2px solid #3b82f6', maxWidth: '800px', margin: '0 auto'}}>
              <h3 style={{color: '#1e40af', marginBottom: '1.5rem'}}>Tailored SMS Marketing Solutions</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem'}}>
                We work with each client to create customized SMS marketing solutions that fit their specific 
                needs and budget. Our pricing is based on message volume, features required, and level of support needed.
              </p>
              
              <div style={{background: 'white', padding: '2rem', borderRadius: '10px', marginBottom: '2rem'}}>
                <h4 style={{color: '#2563eb', marginBottom: '1rem'}}>What's Included:</h4>
                <ul style={{textAlign: 'left', lineHeight: '2', maxWidth: '500px', margin: '0 auto'}}>
                  <li>Access to tier-1 SMS service providers</li>
                  <li>Campaign management support</li>
                  <li>Compliance guidance (TCPA, CAN-SPAM)</li>
                  <li>Analytics and reporting</li>
                  <li>Dedicated account support</li>
                  <li>Integration assistance</li>
                </ul>
              </div>

              <div style={{background: '#2563eb', color: 'white', padding: '2rem', borderRadius: '10px'}}>
                <h4 style={{marginBottom: '1rem'}}>Get Custom Pricing</h4>
                <p style={{marginBottom: '1.5rem'}}>
                  Contact us to discuss your specific requirements and receive a customized quote based on 
                  your expected message volume and feature needs.
                </p>
                <a href="/contact" style={{
                  background: 'white',
                  color: '#2563eb',
                  padding: '12px 32px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  display: 'inline-block'
                }}>Request a Quote</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;